import { useMemo } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import NewProductsBanner from "../../components/cards/NewProductsBanner.jsx";
import SearchBar from "../../components/Search/SearchBar.jsx";
import Catalog from "./Catalog.jsx";
import GoldenSpacing from "../../components/Common/GoldenSpacing.jsx";
import useFetchProducts from "../../hooks/useFetchProducts.js";
import { useSideMenu } from "../../context/SideMenuContext.jsx";
import ConsentNoticeNotification from "../../components/Notification/ConsentNotice.jsx";

const HomePage = () => {
    const { t } = useTranslation();
    const { openMenu } = useSideMenu();
    const { products } = useFetchProducts();

    const hasNewProducts = useMemo(
        () => products?.some((product) => product.is_new),
        [products]
    );

    return (
        <div className="flex flex-col h-full">
            <ConsentNoticeNotification/>
            <div className="search-container flex justify-center items-center w-full pt-6">
                <div className="w-full max-w-[800px] px-4 sm:px-0 mx-auto">
                    <SearchBar />
                </div>
            </div>

            <div className="flex justify-center items-center w-full">
                <div className="w-full px-4 pb-2">
                    <NewProductsBanner />
                </div>
            </div>

            {!hasNewProducts && (
                <GoldenSpacing
                    referenceElementId="header"
                    targetElementClass=".search-container"
                >
                    <div className="flex-grow flex justify-center items-center w-full">
                        <div className="w-full px-4 pb-8">
                            <Catalog />
                        </div>
                    </div>
                </GoldenSpacing>
            )}

            <div className="flex justify-center p-6">
                <Button
                    variant="solid"
                    size="large"
                    className="w-full max-w-xs sm:mb-0"
                    style={{
                        backgroundColor: "#0da98c",
                        borderColor: "#0da98c",
                        color: "white",
                        borderRadius: 0,
                    }}
                    onClick={openMenu}
                >
                    {t("wholeStock")}
                </Button>
            </div>
        </div>
    );
};

export default HomePage;